import { render, staticRenderFns } from "./ClassifiedAdCard.vue?vue&type=template&id=1305d798&scoped=true&"
import script from "./ClassifiedAdCard.vue?vue&type=script&lang=js&"
export * from "./ClassifiedAdCard.vue?vue&type=script&lang=js&"
import style0 from "./ClassifiedAdCard.vue?vue&type=style&index=0&id=1305d798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1305d798",
  null
  
)

export default component.exports